import ThumbGridContainer from './thumb_grid_container';

const ThumbGrid = ThumbGridContainer;
export default ThumbGrid;
